export default function mobileHubNav() {

    const placeInFlow = () => {
        $('.top-nav').append($('#left-nav-phone'));
    };

    placeInFlow();
}


// WEBPACK FOOTER //
// ./scriptPartials/mobileHubNav.js